//@ts-check
import entityModule from '@/common/lib/entity-module';
import { updateResult } from '../result/result.action';
import { appInit, userInit } from './app.action';

const initState = {
  shopId: '',
  web: {},
  valid: false,
  result: '',
  up: {},
  errMsgLogin: '',
  errMsgPassword: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case String(appInit):
      return {
        ...state,
        web: action.payload.web,
        shopId: action.payload.shopId,
        valid: action.payload.validId,
      };
    case String(userInit):
      return {
        ...state,
        web: action.payload.web,
        valid: action.payload.validId,       
        shopId: action.payload.shopId,
      };
    case String(updateResult):
      return {
        ...state,
        result: action.payload
      };
    default:
      return entityModule(state, action);
  }
};